package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.Range


@Composable
fun TextDescription(
    label: String = "",
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    isMobile: Boolean = false,
    isTablet: Boolean = false,
) {
    var isBold by remember { mutableStateOf(false) }
    var isItalic by remember { mutableStateOf(false) }
    var isUnderline by remember { mutableStateOf(false) }
    var isBulletList by remember { mutableStateOf(false) }
    var isNumberedList by remember { mutableStateOf(false) }
    var textAlignment by remember { mutableStateOf(TextAlignment.LEFT) }
    var editorElement by remember { mutableStateOf<HTMLDivElement?>(null) }
    var savedRange by remember { mutableStateOf<Range?>(null) }

    fun saveSelection() {
        val sel = window.asDynamic().getSelection()
        if (sel != null && (sel.rangeCount as Int) > 0) {
            savedRange = sel.getRangeAt(0) as Range
        }
    }

    fun restoreSelection() {
        val range = savedRange ?: return
        val sel = window.asDynamic().getSelection() ?: return
        sel.removeAllRanges()
        sel.addRange(range)
    }

    fun updateToolbarState() {
        isBold = document.queryCommandState("bold")
        isItalic = document.queryCommandState("italic")
        isUnderline = document.queryCommandState("underline")
        isBulletList = document.queryCommandState("insertUnorderedList")
        isNumberedList = document.queryCommandState("insertOrderedList")
    }

    fun execOnEditor(command: String) {
        restoreSelection()
        document.execCommand(command, false, "")
        updateToolbarState()
    }


    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(10.px)
    ) {
        if (label.isNotEmpty()) {
            SpanText(
                text = label,
                modifier = Modifier
                    .color(Colors.White)
                    .fontSize(if (isMobile) 14.px else 16.px)
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Light)
            )
        }
        Box(
            modifier = modifier //ici on mettra tous les styles necessaire ,tailles , couleur , hover ...
                //.width(if (isMobile) 320.px else 800.px)
                .padding(15.px)
                .styleModifier {
                    property("overflow", "visible")
                }
        ) {
            Column {
                TextArea(
                    value = value,
                    onValueChange = onValueChange,
                    editorRef = { editorElement = it },
                    onSelectionChange = {
                        saveSelection()
                        updateToolbarState()
                    },
                    backgroundColor = Colors.border
                )

                TextEditorToolbar(
                    isBold = isBold,
                    onBoldClick = {
                        execOnEditor("bold")
                    },
                    isItalic = isItalic,
                    onItalicClick = {
                        execOnEditor("italic")
                    },
                    isUnderline = isUnderline,
                    onUnderlineClick = {
                        execOnEditor("underline")
                    },
                    isBulletList = isBulletList,
                    onBulletClick = {
                        execOnEditor("insertUnorderedList")
                    },
                    isNumberedList = isNumberedList,
                    onNumberedClick = {
                        execOnEditor("insertOrderedList")
                    },
                    alignment = textAlignment,
                    onAlignmentChange = { alignment ->
                        textAlignment = alignment
                        execOnEditor(
                            when (alignment) {
                                TextAlignment.LEFT -> "justifyLeft"
                                TextAlignment.RIGHT -> "justifyRight"
                                TextAlignment.CENTER -> "justifyCenter"
                                TextAlignment.JUSTIFY -> "justifyFull"
                            }
                        )
                    },
                )
            }
        }
    }
}